<script setup>
import { useRoute } from '@js/utils/route';
import { ref } from 'vue';

const { facebookAdsProductFeed, tenant, callback } = defineProps({
    facebookAdsProductFeed: {
        type: Object,
        required: true,
    },
    tenant: {
        type: Object,
        required: true,
    },
    callback: {
        type: Function,
        required: false,
    },
});

const { route } = useRoute();

const loading = ref(false);

function action() {
    loading.value = true;

    axios
        .post(
            route('front.projectManagement.sma.postGenerateProductFeed', {
                tenant: tenant.id,
                facebookAdsProductFeed: facebookAdsProductFeed.id,
            }),
        )
        .then(() => {
            loading.value = false;

            if (callback) {
                callback();
            }
        })
        .catch((error) => {
            console.error(error);
        });
}
</script>

<template>
    <slot name="button" :action="action" :loading="loading" />
</template>
